import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../shared/modals/modal.component';

import { requiredWhenPresent } from '../../../shared/propTypes';

class EditCustomReportQueryModal extends PureComponent {
  static propTypes = {
    hideModal: PropTypes.func.isRequired,
    saveEntity: PropTypes.func.isRequired,

    entityToEdit: requiredWhenPresent(['isVisible'], PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      sql: PropTypes.string.isRequired,
    })),
    isVisible: PropTypes.bool,
  };

  saveEntity = () => {
    const {
      hideModal,
      saveEntity,
    } = this.props;

    saveEntity();
    hideModal();
  };

  render() {
    const {
      entityToEdit,
      hideModal,
      isVisible,
    } = this.props;

    return (
      <Modal
        className="edit-query-modal"
        title="Edit Query"
        closeAction={hideModal}
        dismissText="Cancel"
        dismissAction={hideModal}
        submitText="Yes"
        submitAction={this.saveEntity}
        isVisible={isVisible}
      >
        { entityToEdit
          ? (
            <div>
              Are you sure you want to apply changes to the query? <br/>
              Your action will generate a run-time error if the query is being called within TLS. <br/><br/>
              Query ID: {entityToEdit.id}<br/>
              Query Name: {entityToEdit.name}<br/>
              Query: {entityToEdit.sql}<br/><br/>
            </div>
          )
          : null
        }
      </Modal>
    );
  }
}

export default EditCustomReportQueryModal;
